import Button from '@material-ui/core/Button';
import type { ButtonProps } from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import PlaylistAdd from '@material-ui/icons/PlaylistAdd';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

import Colors from 'src/nightingale/Colors';

type ActionButtonProps = ButtonProps & {
  isLoading: boolean;
};

export const ActionButton = ({ isLoading, children, disabled, onClick }: ActionButtonProps) => {
  const styles = useStyles();

  return (
    <Button
      data-testid="chart-element-confirm-button"
      onClick={onClick}
      classes={{ root: styles.iconButton }}
      startIcon={isLoading ? <CircularProgress size={12} color="inherit" /> : <PlaylistAdd />}
      disabled={isLoading || disabled}
    >
      {children}
    </Button>
  );
};

const useStyles = makeStyles({
  iconButton: {
    alignItems: 'center',
    backgroundColor: Colors.Stillwater,
    border: 'none',
    borderRadius: 0,
    color: Colors.White,
    cursor: 'pointer',
    fontFamily: '"Nunito", "Nunito Sans"',
    fontSize: 12,
    fontWeight: 'bold',
    justifyContent: 'center',
    letterSpacing: 1.12,
    margin: '16px 16px 0 0',
    padding: '8px 16px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: Colors.BlueSpruce,
    },
  },
});
